<template>
  <layout-header />
  <layout-sidebar />

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />

        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
          <!-- Year selector -->
          <div class="input-icon-end position-relative" style="min-width: 180px">
            <select
              class="form-select"
              v-model.number="year"
              :disabled="store.myP9Loading || store.myP9Downloading"
            >
              <option v-for="y in years" :key="y" :value="y">
                {{ y }}
              </option>
            </select>
            <span class="input-icon-addon"><i class="ti ti-calendar"></i></span>
          </div>

          <button
            class="btn btn-outline-secondary"
            :disabled="store.myP9Loading"
            @click="reloadYears"
            title="Refresh available years"
          >
            <span v-if="store.myP9Loading" class="spinner-border spinner-border-sm me-1"></span>
            <i v-else class="ti ti-refresh"></i>
            <span class="ms-1 d-none d-md-inline">Refresh</span>
          </button>

          <button
            class="btn btn-primary"
            :disabled="!year || store.myP9Downloading"
            @click="download"
          >
            <span v-if="store.myP9Downloading" class="spinner-border spinner-border-sm me-1"></span>
            <i v-else class="ti ti-download me-1"></i>
            Download P9
          </button>

          <div class="head-icons ms-2">
            <a id="collapse-header" @click="toggleHeader">
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Body Card -->
      <div class="card">
        <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-2">
          <div>
            <h5 class="mb-1">My P9 Form</h5>
            <div class="text-muted fs-12">
              Select a year and download your P9.
            </div>
          </div>

          <div class="text-muted fs-12">
            <span v-if="years.length">Available years: {{ years.length }}</span>
            <span v-else>—</span>
          </div>
        </div>

        <div class="card-body">
          <div v-if="store.myP9Loading" class="text-center py-4">
            <div class="spinner-border"></div>
            <div class="text-muted mt-2">Loading your P9 years…</div>
          </div>

          <div v-else>
            <div v-if="!years.length" class="alert alert-warning mb-0">
              No P9 data available yet. This usually means payroll hasn’t been processed for any months.
            </div>

            <div v-else class="d-flex align-items-start gap-3">
              <div class="avatar avatar-xl bg-light border rounded">
                <i class="ti ti-file-text text-primary" style="font-size: 28px;"></i>
              </div>

              <div class="flex-grow-1">
                <div class="fw-semibold mb-1">P9 for year {{ year }}</div>
                <div class="text-muted fs-12 mb-3">
                  This download is restricted to your account.
                </div>

                <button
                  class="btn btn-primary"
                  :disabled="store.myP9Downloading"
                  @click="download"
                >
                  <span v-if="store.myP9Downloading" class="spinner-border spinner-border-sm me-1"></span>
                  <i v-else class="ti ti-download me-1"></i>
                  Download PDF
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useEmployeeSalaryStore } from "@/stores/employeeSalaryStore";
import { toast } from "@/utils/toast";

defineOptions({ name: "MyEmployeeP9" });

const title = "My P9";
const text = "Employee";
const text1 = "My P9";

const store = useEmployeeSalaryStore();
const year = ref(new Date().getFullYear());

const years = computed(() => store.myP9Years || []);

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

async function reloadYears() {
  const data = await store.fetchMyP9Years();
  const defaultYear = data?.default_year || store.myP9DefaultYear || new Date().getFullYear();

  // pick default if current year not in list
  if (!years.value.includes(year.value)) {
    year.value = years.value.includes(defaultYear) ? defaultYear : (years.value[0] || defaultYear);
  }
}

async function download() {
  try {
    if (!year.value) return;
    await store.downloadMyP9(year.value);
  } catch (e) {
    toast("Failed to download P9", "error");
  }
}

onMounted(reloadYears);
</script>


